import * as React from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import styled from 'styled-components';

import { Translate } from 'react-localize-redux';

import AppState from '@webapp/store/state';
import { ResendCode } from '@webapp/store/auth/action-creators';
import { RESEND_CODE, RESEND_CODE_ERROR } from '@webapp/store/auth/actions';

import ErrorCtrl from '@webapp/controllers/error';

import Flex from '@components/layout/flex';
import { getWidth } from '@components/styles';
import Typography from '@components/basics/typography';
import CircleCheckIcon from '@components/basics/icons/circle-check';
import Hint, { HintText, HintTitle } from '@components/basics/hint';
import Grid from '@components/basics/grid';

interface ResendCodeCtrlProps {
  className?: string;
  username: string;
  loading: boolean;
  success: boolean;
  isMobile: boolean;
  contact?: string;
  resendCode: (username: string) => ResendCode;
}

const mapStateToProps = (state: AppState) => ({
  loading: !!state.ui.loading[RESEND_CODE],
  success: !!state.auth.resendCodeSuccess,
  isMobile: state.ui.mobile,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  resendCode: (username: string) => dispatch(new ResendCode(username)),
});

export const ResendCodeCtrl: React.FC<ResendCodeCtrlProps> = (props) => {
  const [success, setSuccess] = React.useState(false);
  const [done, setDone] = React.useState(false);

  const propsSuccess = props.success;

  React.useEffect(() => {
    if (propsSuccess && !done) {
      setDone(true);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 2000);
    }
  }, [propsSuccess, done]);

  const handleSubmit = () => {
    setDone(false);

    props.resendCode(props.username);
  };

  return (
    <Grid gap={5}>
      <Hint
        className={props.className}
        noTitle
        align="left"
        customContent={
          <Flex
            gap={20}
            alignItems="center"
            justifyContent="space-between"
            flexDirection={props.isMobile ? 'column' : 'row'}
          >
            <Grid gap={5}>
              <HintTitle weight="700">
                {props.contact ? (
                  <Translate id="AUTH.VERIFY.HINT.TITLE.WITHCONTACT" data={{contact: props.contact.length > 15 ? `${props.contact.substring(0, 15)}...` : props.contact}} />
                ) : (
                <Translate id="AUTH.VERIFY.HINT.TITLE" />
                )}
              </HintTitle>
              <HintText>
                <Translate id="AUTH.VERIFY.HINT.TEXT" />
              </HintText>
            </Grid>
            {success ? (
              <CircleCheckIcon noCircle />
            ) : (
              <Link weight="700" onClick={handleSubmit}>
                {!!props.loading ? (
                  <Translate id="AUTH.VERIFY.HINT.LINK.SENDING" />
                ) : (
                  <Translate id="AUTH.VERIFY.HINT.LINK" />
                )}
              </Link>
            )}
          </Flex>
        }
      />
      <ErrorCtrl hasBackground type={RESEND_CODE_ERROR} />
    </Grid>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(ResendCodeCtrl)`
  .text {
    margin-bottom: 8px;

    @media ${({ theme }) => theme.device.mobileL} {
      flex-basis: ${getWidth(3)};
      margin-bottom: 0;
    }
  }
`);

const Link = styled(Typography)`
  cursor: pointer;
  opacity: 1;
  transition: opacity
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &:hover {
    opacity: 0.5;
  }
`;
